import { gql } from '@apollo/client';

export const listTransactionsV2 = gql`
  query listTransactionsV2Extend($input: ListTransactionsV2Input!) {
    listTransactionsV2(input: $input) {
      page
      pageSize
      total
      edges {
        vendorId
        items {
          altId
          quantity
          unitPrice
          productType {
            columnText
          }
          taxRate
          calculatedAmount
          calculatedUnitPrice
        }
        session {
          altId
          vendorId
          connector {
            connectorType {
              columnText
            }
            evse {
              charger {
                chargerName
                site {
                  siteName
                  timeZone
                }
              }
            }
          }
          plan {
            planName
            chargerGroup {
              altId
              chargerGroupName
            }
          }
          stopSource {
            columnText
          }
          startSource {
            columnText
          }
          startTime
          endTime
          startTimeLocal
          endTimeLocal
          meterStart
          meterEnd
          cost
        }
        altId
        tax
        amount
        calculatedAmount
        calculatedTaxAmount
        isCalculated
        type {
          columnText
        }
      }
    }
  }
`;
